import * as api from "@/api/williams/dashboard";
import { queryKeys } from "../../queryKeys";
import { useQuery } from "react-query";

export function useDashboardStats() {
  return useQuery(queryKeys.dashboard.stats(), () => {
    return api.getDashboardStats();
  });
}
